import {
  GetCmsClasesAsignables,
  GetCmsProductosOperacion,
  PostCmsAsignacion,
  PutCmsOmitirCaducidad,
  GetCmsHistorialDocumentos,
  PutCmsRecuperarDocumento
} from "../../../reducers/comisionesV2";
import * as actions from "../../../actions/comisionesV2";
import { Preview } from "../../../../types/IAction";
import { RequestArchivo } from "../../../components/expedientsV2controls/types";
import { putCincelFirmas } from "../../../actions/expedientes";

export interface BAsignacionDispatcher {
  getCmsClasesAsignables: (
    params?: any
  ) => Promise<Preview<GetCmsClasesAsignables>>;
  getCmsProductosOperacion: (
    params?: any
  ) => Promise<Preview<GetCmsProductosOperacion>>;
  postCmsAsignacion: (
    body: any,
    esClasePersonalizada: boolean
  ) => Promise<Preview<PostCmsAsignacion>>;
  putCmsArchivo: (
    idInstancia: any,
    requestArchivo: RequestArchivo
  ) => Promise<Preview<any>>;
  putCincelFirmas: (idExpediente: any, idItem: any) => Promise<Preview<any>>;
  putCmsOmitirCaducidad: (
    idInstancia: any,
    body: any
  ) => Promise<Preview<PutCmsOmitirCaducidad>>;
  getCmsHistorialDocumentos: (
    idInstancia: any,
    codigo: string
  ) => Promise<Preview<GetCmsHistorialDocumentos>>;
  putCmsRecuperarDocumento: (
    idInstancia: any,
    codigo: string,
    idExpediente: any,
    idItem: any
  ) => Promise<Preview<PutCmsRecuperarDocumento>>;
}

export const bAsignacionDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => BAsignacionDispatcher = dispatch => ({
  getCmsClasesAsignables: (params?: any) => {
    return dispatch(actions.getCmsClasesAsignables(params));
  },
  getCmsProductosOperacion: (params?: any) => {
    return dispatch(actions.getCmsProductosOperacion(params));
  },
  postCmsAsignacion: (body: any, esClasePersonalizada: boolean) => {
    return dispatch(actions.postCmsAsignacion(body, esClasePersonalizada));
  },
  putCmsArchivo: (
    idInstancia: any,
    requestArchivo: RequestArchivo
  ): Promise<Preview<any>> => {
    return dispatch(actions.putCmsArchivo(idInstancia, requestArchivo));
  },
  putCincelFirmas: (idExpediente: any, idItem: any): Promise<Preview<any>> => {
    return dispatch(putCincelFirmas(idExpediente, idItem));
  },
  putCmsOmitirCaducidad: (
    idInstancia: any,
    body: any
  ): Promise<Preview<PutCmsOmitirCaducidad>> => {
    return dispatch(actions.putCmsOmitirCaducidad(idInstancia, body));
  },
  getCmsHistorialDocumentos: (
    idInstancia: any,
    codigo: string
  ): Promise<Preview<GetCmsHistorialDocumentos>> => {
    return dispatch(actions.getCmsHistorialDocumentos(idInstancia, codigo));
  },
  putCmsRecuperarDocumento: (
    idInstancia: any,
    codigo: string,
    idExpediente: any,
    idItem: any
  ): Promise<Preview<PutCmsRecuperarDocumento>> => {
    return dispatch(
      actions.putCmsRecuperarDocumento(
        idInstancia,
        codigo,
        idExpediente,
        idItem
      )
    );
  }
});
